import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LocalStorageService from '../../../application/features/common/local-storage-service';
import { useAppDispatch } from '../../../application/store/useStore';
import { loginAsync } from '../../../application/features/auth/authThunk';
import { loginRequest } from '../../../auth-config';
import { LoginStyle } from './styles';
import { Icon } from '@iconify/react';
import Logo from './VDKLogo.svg';
export const Login = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { instance } = useMsal();
    const LoginStyles = LoginStyle();
    const loginIcon = isLoggingIn ? (_jsx(CircularProgress, { color: 'secondary', size: '22px' })) : (_jsx(Icon, { icon: 'logos:microsoft-icon', width: 24, height: 24, color: 'default' }));
    const loginText = isLoggingIn ? `${t('loggingIn')}...` : t('loginWithMicrosoft');
    useEffect(() => {
        setIsLoggingIn(true); // Keep loader active until redirect handling is completed
        instance
            .handleRedirectPromise()
            .then((response) => {
            if (response) {
                const { account, accessToken } = response;
                LocalStorageService.setMSAccessToken(accessToken);
                instance.setActiveAccount(account);
                dispatch(loginAsync())
                    .unwrap()
                    .then((response) => {
                    if (response) {
                        console.log('navigating to proposals page...');
                        navigate('/proposal');
                    }
                })
                    .catch((error) => {
                    console.error('Login failed:', error);
                    // If login fails, clear the MS token and stay on login page
                    LocalStorageService.removeMSAccessToken();
                })
                    .finally(() => {
                    setIsLoggingIn(false); // Disable loader after login attempt completes
                });
            }
            else {
                setIsLoggingIn(false); // Disable loader if no response (e.g., user didn't complete login)
            }
        })
            .catch((error) => {
            console.error('Error during redirect handling:', error);
            setIsLoggingIn(false); // Ensure loader is disabled in case of an error
        });
    }, [instance, dispatch, navigate]);
    const loginMsl = async () => {
        if (isLoggingIn)
            return; // Prevent multiple clicks
        setIsLoggingIn(true); // Ensure button stays disabled immediately
        console.log('AUTH_CLIENT_ID:', process.env.REACT_APP_AUTH_CLIENT_ID);
        // Clear any existing tokens to ensure fresh authentication
        LocalStorageService.removeMSAccessToken();
        // Proceed with Microsoft login redirect
        try {
            await instance.loginRedirect(loginRequest);
        }
        catch (error) {
            console.error('Login failed:', error);
            setIsLoggingIn(false); // Reset only if login fails
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: LoginStyles.backgroundImage }), _jsxs(Box, { sx: LoginStyles.loginBox, children: [_jsx(Typography, { color: theme.palette.common.white, variant: 'h1', children: t('WelcomeTo') }), _jsx(Box, { component: 'img', src: Logo, width: 'auto', height: 300, alt: 'Tender AI' }), _jsx(Typography, { color: theme.palette.common.white, variant: 'h3', children: "AI Tender" }), _jsx(Button, { fullWidth: true, size: 'large', startIcon: _jsx(Icon, { icon: 'logos:microsoft-icon', width: 24, height: 24, color: 'default' }), variant: 'contained', color: 'primary', onClick: loginMsl, disableElevation: true, children: loginText })] })] }));
};
